// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"362":"480ed2d6","798":"323898e4","995":"a98ae29f"}[chunkId] + ".js";
};